import gql from "graphql-tag"; // eslint-disable-line import/no-named-as-default
import { print } from "graphql/language/printer";

export const storeQuery: string = print(gql`
  query ($slug: String!) {
    storeBySlug(slug: $slug) {
      abilities
      amenities
      city
      classesUrl
      country
      email
      eventsUrl
      hasMirror
      facebookUrl
      facebookUsername
      friendlyFromName
      fullAddress
      waitwhileServiceId
      heroImage {
        id
        url
        displayOrder
        accessibilityText
        tags
      }
      hours {
        name
        openHour
        closeHour
      }
      specialHours {
        date
        description
        openHour
        closeHour
      }
      id
      images {
        id
        url
        displayOrder
        accessibilityText
        tags
      }
      instagramHandle
      instagramUrl
      isExperiential
      latitude
      liveChatUrl
      longitude
      message
      name
      phone
      slug
      spaces {
        spaceType
        images {
          id
          accessibilityText
          displayOrder
          tags
          url
        }
        id
        about
        aboutHtml
        amenities
        bookingEmail
        displayOrder
        fuelMenuPdfKeywords
        fuelMenuPdfUrl
        fuelMenuUrl
        hours {
          name
          openHour
          closeHour
        }
        longDescription
        name
        shortDescription
      }
      state
      storeNumber
      storeType
      storeStatus
      twitterHandle
      twitterUrl
      storeLocatorAmenities {
        footwear
        hasMirror
        personalShopping
        likeNew
        buyOnlinePickupStore
        curbsidePickup
        complementaryHemming
        returnsExchanges
      }
      waitwhileFootwearId
    }
  }
`);
